// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { AppBar, AppBarProps, Typography } from '@teamnine/pcj-ui-v2'
import { useTheme } from 'styled-components'
import { useAuth0 } from '@auth0/auth0-react'

import { useLayout } from '@/app/shared/components/Layout/layout-context'
import UserPicker from '@/app/shared/components/Layout/Navigation/SideNav/UserPicker'

export type PageAppBarProps = Omit<AppBarProps, 'aside'> & {
  isGlobal?: boolean
}

export default function PageAppBar({ isGlobal = false }: PageAppBarProps) {
  const { colors } = useTheme()
  const { user } = useAuth0()
  const { useAside } = useLayout({
    ignoreError: true,
  })

  if (!isGlobal) return null

  return (
    <>
      {isGlobal && (
        <AppBar
          variant="inverse"
          customTitle={
            <Typography variant="header-m" color={colors.white}>
              Tenant Cloud Configurator
            </Typography>
          }
          aside
          extras={[
            <UserPicker key="user-picker" isCollapsed={useAside} user={user} />,
          ]}
        />
      )}
    </>
  )
}
